import React from 'react';
import PropTypes from 'prop-types';
import Input from '@welldev-group/rcl-input';

const SubscriptionInput = ({
  className,
  labelKey,
  placeholderKey,
  name,
  value,
  onChange,
  onBlur,
  error,
  touched,
}) => {
  const handleChange = val => {
    onChange(name, val);
  };

  return (
    <Input
      className={className}
      label={labelKey}
      placeholder={placeholderKey}
      name={name}
      value={value}
      onChange={handleChange}
      onBlur={onBlur}
      error={error}
      touched={touched}
      required={true}
    />
  );
};

SubscriptionInput.propTypes = {
  className: PropTypes.string,
  labelKey: PropTypes.string.isRequired,
  placeholderKey: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  touched: PropTypes.bool,
};

SubscriptionInput.defaultProps = {
  className: null,
  error: null,
  touched: false,
};

export default SubscriptionInput;
